<template>
  <div v-if="!modal">
    <div
      v-for="(data, index) in $store.state.tabManagement.tabs"
      :key="data.route.name"
    >
      <div v-show="$store.state.tabManagement.activeTab === index">
        <div v-if="data.form">
          <AbrFormContainer
            :key="renderObject[data.route.name]"
            :def="data.form"
            :mode="data.mode"
            :model="data.model"
            :modal="data.modal"
            :callback="callback"
          ></AbrFormContainer>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="dataInitiated">
    <AbrFormContainer
      :def="form"
      :mode="mode"
      :model="Model"
      :modal="modal"
    ></AbrFormContainer>
  </div>
</template>

<script>
import AbrFormContainer from "./AbrFormContainer";
import {fetchDefData, fetchFormData} from "@/apis";
import Vue from "vue";
import {extend} from "@/ext";

export default {
  name: "AbrRoot",
  components: {
    AbrFormContainer,
  },
  provide() {
    return {
      changeFormMode: newValue => this.changeFormMode(newValue)
    }
  },
  props: ["formId", "mode", "model", "modal", "callback"],
  data: function() {
    return {
      dataInitiated: false,
      Model: this.model,
      renderObject : {}
    }
  },
  computed: {
    form() {
      return this.$store.state.forms.find((f) => f.id === this.formId)
    },
  },
  async created() {
    console.log("abr root has been created...");
    this.$watch("$route", async (to, from) => {
      if(this.modal) {
        await this.initModalData();
        return;
      }
      await this.beforeRouteEnterOrUpdate(to, from);
    }, { immediate: true });
    this.$eventBus.$on("changeModelOnAction", payload => {
      // for(let i in payload)
      //   if(Array.isArray(payload[i])){
      //     this.model[i].splice(0)
      //     for(let ai in payload[i])
      //       this.model[i].push(payload[i][ai])
      //   } else this.$set(this.model, i, payload[i])
      const activeForm = this.$store.getters.getCurrentForm;
      activeForm.model = payload;
      
      if(activeForm.route){
        this.renderObject[activeForm.route.name] = !this.renderObject[activeForm.route.name];
      }else{
        this.renderObject[activeForm.formId] = !this.renderObject[activeForm.formId]
      }
      
    })

    this.$eventBus.$on("ResetForm", () => {
      const activeForm = this.$store.getters.getCurrentForm;
      this.resetForm(activeForm);
    });
    // this.$watch("$route", async (to, from) => {
    //   if(this.modal) {
    //     await this.initModalData();
    //     return;
    //   }
    //   await this.beforeRouteEnterOrUpdate(to, from);
    // }, { immediate: true, deep: true });
  },
  // beforeUpdate() {
  //   this.Model = this.$proxy(this.Model)
  // },
  methods: {
    getVersion(ID) {
      let id = null;
      if(this.mode === "ECore.Def.DefEnums.fmCreate") {
        if (this.Model.ID) {
          id = this.Model.ID
        }
        id = "$new";
      } else {
        // const modelID = ID || this.Model?.ID;
        let modelID =  ID || this.Model?.ID;
        const endorseNo = this.$route.params.id.toString()?.split(":")?.length > 1 ? this.$route.params.id.toString()?.split(":")?.pop() : ""
        if (endorseNo) {
          modelID = `${modelID}:${endorseNo}`
        }
        const endorseRegex = /:+(([0-9]+)|(\bfirst\b)|(\bnone\b)|(\bunversioned\b)|(\bpropagate\b)|(\bcurrent\b)|(\blatest\b)|(\bdraft\b)|(\ball\b))/
        id = endorseRegex.test(modelID && modelID.toString()) ? modelID : `${modelID}:first`;
        // id = modelID.toString().includes(":") ? modelID : `${modelID}:first`;
      }
      return id;
    },
    async initModalData() {
      if (!this.form) {
        await this.fetchForm(this.formId)
      }
      if(this.form.origin && (this.form.isSelfCRUD || this.mode === "ECore.Def.DefEnums.fmCreate")) {
        // let id = null;
        // if(this.mode === "ECore.Def.DefEnums.fmCreate") {
        //   id = "$new";
        // } else {
        //   const modelID = this.Model?.ID;
        //   id = modelID.toString().includes(":first") ? modelID : `${modelID}:first`;
        // }
        
        const entity = await fetchFormData(this.form.origin?.name, this.getVersion(), this.form.id);
        if(this.Model)
          for(let i in entity)
            if(this.Model[i] === undefined || this.Model[i] === null || Array.isArray(this.Model[i]))
              this.$set(this.Model, i, entity[i]);
      }

      for (let panel of (this.form.pages || []).flatMap(p => p.sections || []).flatMap(s => s.panels || [])) {
        let e = this.Model;

        if(!e) break;

        const path = panel.relationPath && panel.relationPath.split(".") || [];

        for (let ix in path) {
          //TODO this is based on whether there are any properties on the panel. It should probably find the rel instead
          const p = path[ix]
          if (e[p] == null)
            e[p] = ix < path.length - 1 || panel.grids && panel.grids.length ? [] : {}
          e = e[p]
        }
      }
      this.Model = Vue.observable(this.Model);
      this.dataInitiated = true;
    },
    resetForm(activeForm) {
      if(activeForm.route){
        this.renderObject[activeForm.route.name] = !this.renderObject[activeForm.route.name];
      }else{
        this.renderObject[activeForm.formId] = !this.renderObject[activeForm.formId]
      }
    },
    changeFormMode(payload) {
      const activeForm = this.$store.getters.getCurrentForm;
      activeForm.mode = payload;
      this.resetForm(activeForm);
      // this.renderObject[activeForm.route.name] = !this.renderObject[activeForm.route.name]
    },
    beforeRouteEnterOrUpdate: async function (to, from) {
      const store = this.$store;

      store.commit("SET_APP", to.params.app);

      let tabs = store.state.tabManagement.tabs;
      // TODO => Dont open the same tab in Create Mode
      let index = tabs.findIndex(tab => tab.route.path === to.path && tab.route.params.mode === to.params.mode);

      if (index !== -1) {
        store.commit('SET_ACTIVE_TAB', index);
        return;
      }
      to.params.form = to.params.form || store.state.forms.find(f => f.id === (to.params.formId || to.meta.formId)) || await this.fetchForm(to.params.formId || to.meta.formId)
      await this.beforeLoad(to, from);
      const data = {
        model: Vue.observable(to.params.model),
        form: to.params.form,
        mode: Vue.observable(to.params.mode),
        modalForm: [],
        pageForm: undefined,
        route: to,
        pagesScrollPos: {},
        lastActiveTab : from
      }
      this.$nextTick(async () => {
        index = tabs.findIndex(tab => tab.route.name === to.name);
        if (index === -1) {
          store.commit('ADD_TAB', data);
          store.commit('SET_ACTIVE_TAB', store.state.tabManagement.tabs.length - 1);
        } else {
          await store.dispatch("DELETE_TAB", index);
          store.commit('REPLACE_TAB', { payload: data, index});
          store.commit('SET_ACTIVE_TAB', index);
        }
      })
    },
    async beforeLoad(to) {
      if (to.params.form) {
        const form = to.params.form
        //TODO what needs to happen if form can not be found?
        const entityId = form && form.origin && form.origin.name;

        let entity

        if (entityId) {
          // const id = (to.params.id).includes(":first") ? to.params.id : `${to.params.id}:first`
          let id = null;
          if(this.$route.params.id === "$new") {
            id = "$new";
          } else {
            const modelID = to.params.id;
            const endorseRegex = /:+(([0-9]+)|(\bfirst\b)|(\bnone\b)|(\bunversioned\b)|(\bpropagate\b)|(\bcurrent\b)|(\blatest\b)|(\bdraft\b)|(\ball\b))/
            id = endorseRegex.test(modelID.toString()) ? modelID : `${modelID}:first`;
            // id = modelID.toString().includes(":") ? modelID : `${modelID}:first`;
          }
          entity = await fetchFormData(entityId, id, form.id);
        } else {
          entity = {}
        }

        for (let panel of (form.pages || []).flatMap(p => p.sections || []).flatMap(s => s.panels || [])) {
          let e = entity

          let m = to.params.model

          const copyModelToEntity = () => {
            if (m && panel.properties) {
              panel.properties.forEach(p => {
                if (!(p.name in e) && p.name in m) {
                  e[p.name] = m[p.name]
                }
              })
            }
          }

          const path = panel.relationPath && panel.relationPath.split(".") || []

          for (let ix in path) {
            //TODO this is based on whether there are any properties on the panel. It should probably find the rel instead
            const p = path[ix]
            if (e[p] == null)
              e[p] = ix < path.length - 1 || panel.grids && panel.grids.length ? [] : {}

            m = m && m[p]
            e = e[p]
          }

          copyModelToEntity()
        }
        if(to.params.model)
          to.params.model = { ...to.params.model, ...Vue.observable(entity) };
        else
          to.params.model = Vue.observable(entity);
        if (!to.params.mode)
          to.params.mode = to.params.id === "$new" ? "ECore.Def.DefEnums.fmCreate" : "ECore.Def.DefEnums.fmView";
      }
    },
    async fetchForm(formId) {
      const store = this.$store;
      const form = await fetchDefData(formId, {resources: false, routes: false});
      store.state.forms.push(form);
      extend(form);
      return this.$traverseData(form);
    }
  }
};
</script>
<style>
.loading {
  /*background-color: rgba(40,40,40, 0.2);*/
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>